import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, BadgePercent } from 'lucide-react';

const ClientPromotionsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in" data-testid="client-promotions-page">
      <button onClick={() => navigate('/client/supplements')} className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors" data-testid="back-to-supplements">
        <ArrowLeft size={16} /> Suplementos
      </button>
      <div className="pt-1">
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Promociones
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Ofertas y descuentos especiales</p>
      </div>
      <div className="bg-white rounded-3xl border border-gray-100/50 shadow-sm p-10 text-center" data-testid="promotions-coming-soon">
        <div className="w-20 h-20 bg-gradient-to-br from-red-50 to-rose-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <BadgePercent size={32} className="text-red-300" />
        </div>
        <p className="font-bold text-gray-700 text-lg" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Proximamente</p>
        <p className="text-sm text-gray-400 mt-1">Las promociones estaran disponibles pronto</p>
      </div>
    </div>
  );
};

export default ClientPromotionsPage;
